<template>
  <div class="chat-message">

    <div class="message-containd message-contain--my">

      <!-- type6 系统客服 -->
      <div class="image-box_my" v-if="item.content.type == 6">
        <div class="system_card">

          <!-- readType 0:自动回复 -->
          <div class="menu" v-if="item.content.payload.readType === 0">
            <div class="text">好哒，我们这边会尽快联系卖家~<br>您可前往
              <span>[个人中心-议价中心]</span>查看砍价详情
            </div>
          </div>

          <!--readType：2 卖家还价后 买家同意了直接去支付 -->
          <div class="image-box_agree" v-if="item.content.payload.readType == 2">
            <div class="kanjia_card">
              <div>买家同意了我们的还价</div>
              <div class="card">
                <div class="title">商品编号:{{ item.content.payload.txt }}</div>
                <div class="content">
                  <div class="left">
                    <el-image
                        style="width: 60px; height: 60px;border-radius: 5px"
                        :src="item.content.payload.thumb">
                    </el-image>
                  </div>
                  <div class="right">
                    <div class="three-line-ellipsis">
                      {{ item.content.payload.title }}
                    </div>
                    <div class="price">{{ '¥' + item.content.payload.old_price }}</div>
                  </div>
                </div>
              </div>
              <div class="text1">还价金额为<span>{{ '¥' + item.content.payload.price }}</span>
              </div>
            </div>
          </div>

          <!--卖家直接拒绝买家的还价后自动发的消息-->
          <div class="image-box_agree" v-if="item.content.payload.readType == 4">
            <div class="kanjia_card">
              <div style="color: red">已经拒绝买家的砍价</div>
              <div class="card">
                <div class="title">商品编号:{{ item.content.payload.txt }}</div>
                <div class="content">
                  <div class="left">
                    <el-image
                        style="width: 60px; height: 60px;border-radius: 5px"
                        :src="item.content.payload.thumb">
                    </el-image>
                  </div>
                  <div class="right">
                    <div class="three-line-ellipsis">
                      {{ item.content.payload.title }}
                    </div>
                    <div class="price">{{ '¥' + item.content.payload.old_price }}</div>
                  </div>
                </div>
              </div>
              <div class="text1" style="text-decoration: line-through">买家还价金额为<span>{{ '¥' + item.content.payload.price }}</span>
              </div>
            </div>
          </div>

        </div>
      </div>



      <!--type为5的分类-->
      <div class="image-box_agree" v-if="item.content.type == 5">
        <!-- readType：1 客服还价自动发送的消息-->
        <div class="kanjia_card" v-if="item.content.payload.readType == 1">
          <div>您好，我们跟卖家进行沟通后，卖家认为<span class="price">{{ '¥' + item.content.payload.buyer_price }}</span>，无法接受，不过可以接受<span
              class="price">{{ '¥' + item.content.payload.seller_price }}</span></div>

          <div class="card">
            <div class="title">商品编号:{{ item.content.payload.txt }}</div>
            <div class="content">
              <div class="left">
                <el-image
                    style="width: 60px; height: 60px;border-radius: 5px"
                    :src="item.content.payload.thumb">
                </el-image>
              </div>
              <div class="right">
                <div class="three-line-ellipsis">
                  {{ item.content.payload.title }}
                </div>
                <div class="price">{{ '¥' + item.content.payload.goods_price }}</div>
              </div>
            </div>
          </div>
        </div>

        <!--readType：3 客服同意砍价自动发送的消息-->
        <div class="kanjia_card" v-if="item.content.payload.readType == 3">
          <div>已同意买家的砍价</div>

          <div class="card">
            <div class="title">商品编号:{{ item.content.payload.txt }}</div>
            <div class="content">
              <div class="left">
                <el-image
                    style="width: 60px; height: 60px;border-radius: 5px"
                    :src="item.content.payload.thumb">
                </el-image>
              </div>
              <div class="right">
                <div class="three-line-ellipsis">
                  {{ item.content.payload.title }}
                </div>
                <div class="price">{{ '¥' + item.content.payload.old_price }}</div>
              </div>
            </div>
          </div>
          <div class="text1">买家的砍价金额为<span>{{ '¥' + item.content.payload.price }}</span>
          </div>
        </div>


      </div>




    </div>

    <!-- Avatar -->
    <div class="chat-message-avatar">
      <el-avatar class="message-avatar" :size="40" :src="avatar"></el-avatar>
    </div>

  </div>
</template>


<script>
export default {
  name: 'ChatMessage',
  props: ['item', 'avatar'],
  mounted() {
  },
}
</script>

<style lang="scss" scoped>
.chat-message {
  display: inline-flex;

  //文本超出隐藏 3行
  .three-line-ellipsis {
    display: -webkit-box;
    -webkit-box-orient: vertical;
    -webkit-line-clamp: 3; /* 设置为你希望的行数 */
    overflow: hidden;
    text-overflow: ellipsis;
    white-space: normal; /* 确保在非截断情况下可以换行 */
  }

  .message-contain--my {
    margin-right: 10px;

    color: #FFFFFF;

    .message-nickname {
      text-align: right;
    }

    .role_tag {
      left: -30px;
      position: absolute;
      margin-left: 5px;
      font-size: 12px;
      color: red;
      border: 1px solid #fff;
      border-radius: 5px;
    }

    .role_kefu {
      font-size: 11px;
      box-sizing: border-box;
      height: 20px;
      border-radius: 5px;
      padding: 2px 5px;
      background-color: red;
      color: #fff;
    }
  }

  .chat-message-avatar {
    display: flex;
    flex-direction: column;
    align-items: center;
  }

  //系统客服
  .system_card {
    border: 1px solid #efefef;
    border-radius: 10px;
    background-color: #fff;
    color: black;

    .menu {
      padding: 15px 10px;
      font-size: 14px;

      .text {
        span {
          color: red;
        }
      }

      .btnMenu {
        margin-top: 8px;

        button {
          width: 44%;
        }

        .agree {
          background-color: #FF7B15;
        }
      }
    }


  }

  .image-box_agree {
    border: 1px solid #efefef;
    padding: 5px;
    border-radius: 10px;
    background-color: #fff;
    color: black;

    .price {
      color: red;
    }

    .kanjia_card {
      max-width: 350px;
      //width: 300px;
      background-color: #fff;
      border-radius: 8px;
      padding: 5px 10px;

      .card {
        margin-top: 10px;
        background-color: #f3f3f3;
        padding: 5px 10px;
        width: 100%;
        //height: 200px;
        font-size: 14px;

        .content {
          display: flex;
          align-items: center;
          justify-content: space-between;

          .left {
            //width: 60px;
            //height: 60px;
            margin-right: 8px;

            image {
              border-radius: 5px;
              width: 60px;
              height: 60px;
            }
          }

          .right {
            .price {
              color: red;
              font-size: 14px;
            }
          }
        }
      }

      .text1 {
        margin-top: 5px;
        font-size: 13px;

        span {
          color: red;
        }
      }

      .btnMenu {
        margin-top: 8px;

        button {
          width: 44%;
        }

        .agree {
          background-color: #FF7B15;
          border-color: #FF7B15;
        }
      }
    }
  }


}


</style>
